export const weBindInfo = [
  {
    profession_code: ['amministratore_condominio'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              Ove l'Assicurato abbia iniziato l'atttività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.
            </p>
            <br />
            <p>
             
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
              5 Anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>
             
              Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Responsabilità Solidale, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, Perizie Consulenze e Certificazioni, D. Lgs. 624/1996, Legge 109/1994 - D. Lgs. 163/06, Contratti con la Pubblica Amministrazione, Spese per il Ripristino della Reputazione, Mediazione Civile, Commerciale e Tributaria, Interruzione o Sospensione Attività di Terzi, Asseverazioni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>
             
              D. Lgs. n. 81/2008, RC della Conduzione dello Studio.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
              La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },
  {
    profession_code: ['ingegnere'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
             Ove l'Assicurato abbia iniziato l'attività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.
            </p>
            <br />
            <p>
             
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
              5 Anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

             Consulenza Ambientale, Certificatore Energetico, Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Responsabilità Solidale, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, D.Lgs. n. 81/2008, D.Lgs. n. 624/1996, L. 109/1994 - D. Lgs. 163/06, Contratti con la Pubblica Amministrazione, Attività di Amministratori di Stabili, Mediazione Civile, Commerciale e Tributaria, Asseverazioni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>
             
              Spese per il ripristino della Reputazione, Inquinamento Accidentale, RC della Conduzione dello Studio, General Contractor Opere ad Alto Rischio.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
             La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },
  {
    profession_code: ['architetto'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
             
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
              5 Anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

             Consulenza Ambientale, Certificatore Energetico, Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Responsabilità Solidale, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, D.Lgs. n. 81/2008, D.Lgs. n. 624/1996, L. 109/1994 - D. Lgs. 163/06, Contratti con la Pubblica Amministrazione, Attività di Amministratori di Stabili, Mediazione Civile, Commerciale e Tributaria, Asseverazioni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>
             
              Spese per il ripristino della Reputazione, Inquinamento Accidentale, RC della Conduzione dello Studio, General Contractor Opere ad Alto Rischio.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
            La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },
  {
    profession_code: ['avvocato'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />

            <p>Ove l'Assicurato abbia iniziato l'attività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.
            </p>
            <br/>
            <p>
             
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             Illimitata.
            </p>
            <br />
               <p>
              <b>Postuma:</b>
             
            10 Anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

             Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Responsabilità Solidale, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, Funzioni di Arbutro, Sostituti d'Udienza, Attività di Amministratore di Stabili, Mediazione Civile, Commerciale e Tributaria. 
            </p>
            <br />
            <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>
             
              Funzioni Pubbliche, Conduzione dello Studio, Spese Ripristino Reputazione, Attività Fiscale e Tributaria.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
            La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },
  {
    profession_code: ['commercialista'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />

            <p>Ove l'Assicurato abbia iniziato l'attività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.

            </p>
            <br/>
            <p>
             
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
             2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

             Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, Funzioni di Arbutro, Servizi di EDP, Attività di Amministratore di Stabili, Mediazione Civile, Commerciale e Tributaria, Spese per il Ripristino della Reputazione, Liquidatore Curatore Commissario, Conduzione dello Studio.
            </p>
            <br />
            <p>
              <b>ESTENSIONI CON SOVRAPREMIO:</b>
             
              Visto Pesante; Visto Leggero, Fusioni e Acquisizioni, Estensione al periodo di Retroattività.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
           La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },
  {
    profession_code: ['consulente_lavoro'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />

            <p>Ove l'Assicurato abbia iniziato l'attività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.
            </p>
            <br/>
            <p>
             
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
            2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

             Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, Funzioni di Arbutro, Servizi di EDP, Attività di Amministratore di Stabili, Mediazione Civile, Commerciale e Tributaria, Spese per il Ripristino della Reputazione, Liquidatore Curatore Commissario, Conduzione dello Studio.
            </p>
            <br />
            <p>
              <b>ESTENSIONI CON SOVRAPREMIO:</b>
             
               Visto Pesante; Visto Leggero, Fusioni e Acquisizioni, Estensione al periodo di Retroattività.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
           La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },
  {
    profession_code: ['agente_immobiliare'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />

            <p>L'ammontare minimo di copertura della polizza stabilito dal ministero è di:</p>
            
            <p>- 260.000 per ditte individuali</p>
            <p>- 520.000 per società di persone</p>
            <p>- 1.550.000 per società di capitali</p>
            <br/>

            <p>
             
            Ove l'Assicurato abbia iniziato l'attività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.
            </p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
            2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

             Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Responsabilità Solidale, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, Perizie, consulenze e certificazioni. 

            </p>
            <br />
            <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>
             
               Spese per il ripristino della Reputazione, RC della Conduzione dello Studio, Interruzione o Sospensione di Attività di Terzi, D. Lgs. n. 81/2008, D. Lgs. n. 624/1996, 109/1994 - D. Lgs. 163/06, Contratti con la Pubblica Amministrazione, Attività di Amministratore di Stabili, mediazione Civile, Commerciale e Tributaria.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['geometra'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />

            <p>
             
           Ove l'Assicurato abbia iniziato l'attività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.
            </p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
            2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

             Consulenza Ambientale, Certificatore Energetico, Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Responsabilità Solidale, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, D.Lgs. n. 81/2008, D.Lgs. n. 624/1996, L. 109/1994 - D. Lgs. 163/06, Contratti con la Pubblica Amministrazione, Attività di Amministratori di Stabili, Mediazione Civile, Commerciale e Tributaria, Asseverazioni.

            </p>
            <br />
            <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>
             
               Spese per il ripristino della Reputazione, Inquinamento Accidentale, RC della Conduzione dello Studio, General Contractor Opere ad Alto Rischio.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
               La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },
  {
    profession_code: ['perito'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />

            <p>
             
           Ove l'Assicurato abbia iniziato l'attività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.

            </p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
             2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

            Spese per il ripristino della Reputazione, RC della Conduzione dello Studio, D. Lgs. n. 81/2008, D. Lgs. n. 624/1996, 109/1994 - D. Lgs. 163/06, Contratti con la Pubblica Amministrazione, Attività di Amministratore di Stabili, mediazione Civile, Commerciale e Tributaria.

            </p>
            <br />
            <p>
              <b>ESTENSIONI CON SOVRAPREMIO:</b>
             
               Visto Pesante; Visto Leggero senza 730; Visto Leggero con 730; Postuma
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                 La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },
  {
    profession_code: ['tributarista'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />

            <p>
             
           Ove l'Assicurato abbia iniziato l'attività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.

            </p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
             2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

           Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, Funzioni di Arbutro, Servizi di EDP, Attività di Amministratore di Stabili, Mediazione Civile, Commerciale e Tributaria, Spese per il Ripristino della Reputazione, Liquidatore Curatore Commissario, Conduzione dello Studio.


            </p>
            <br />
            <p>
              <b>ESTENSIONI CON SOVRAPREMIO:</b>
             
               Visto Pesante; Visto Leggero, Fusioni e Acquisizioni, Estensione al periodo di Retroattività.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                 La Polizza prevede il Tacito Rinnovo, in mancanza di disdetta pervenuta nei 30 giorni antecedenti alla data di scadenza viene automaticamente rinnovata.
            </p>

          </div>
        `,
  },
  {
    profession_code: ['agronomi'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
             2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

          Consulenza Ambientale, Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Responsabilità Solidale, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright. 


            </p>
            <br />
            <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>
             
               Spese per il ripristino della Reputazione, Inquinamento Accidentale, RC della Conduzione dello Studio.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },
  {
    profession_code: ['chimici'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>Tariffa valida per Chimici non Medici.</p>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br/ >
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
            2 Giorni lavorativi dalla ricezione dei documenti.
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />
   
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['geologi'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>Ove l'Assicurato abbia iniziato l'attività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
             2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

         Consulenza Ambientale, Certificatore Energetico, Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Responsabilità Solidale, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, D.Lgs. n. 81/2008, D.Lgs. n. 624/1996, L. 109/1994 - D. Lgs. 163/06, Contratti con la Pubblica Amministrazione, Attività di Amministratori di Stabili, Mediazione Civile, Commerciale e Tributaria, Asseverazioni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>
             
               Spese per il ripristino della Reputazione, Inquinamento Accidentale, RC della Conduzione dello Studio, General Contractor Opere ad Alto Rischio.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },
  {
    profession_code: ['psicologi'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti.
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni inclusi.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

         Primo Soccorso, Cotinuità Assistenziale, Telemedicina e Volontariato, Medico in Sostituzione (solo Medico di Base), Medicina Convenzionale e Vaccinazione, Sonde e Cateteri, Apparecchiature e Strumenti, 81/2008, Tutoring e Docenza, Perizie e Consulenze Tecniche, Fatto di Dipendenti e Collaboratori, Responsabilità Solidale, Tutela dei dati personali, Diffamazione e Danni all'Immagine, Violazione di Copyright.
            </p>
            <br />
            <p>
              <b>ESTENSIONI CON SOVRAPREMIO:</b>
             
              Medico Frequentatore, Medicina del Servizio di Emergenza Sanitaria, Danni alle Attrezzature di Laboratorio, Direttore Sanitario, Commissario di Gara, Componente Organismo di Mediazione, RC Conduzione dello Studio, Spese di Ripristino della Reputazione.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
               La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['dpo_data_protection_officer'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             NON PREVISTA
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

        Perdita Documenti, Fatto di Dipendenti e Collaboratori, Responsabilità Solidale, Tutela Dei Dati Personali, Diffamazione e Danni all'Immagine, Violazione di Copyright.
            </p>
            <br />
           
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['agenzia_di_viaggio_e_tour_operator'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            
            <p>
              <b>ESTENSIONI COMPRESE:</b>

        Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, Consorzio e Joint Venture. 
            </p>
            <br />
             <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>

        Spese per il Ripristino della Reputazione; Conduzione dello Studio, Responsabilità Solidale.
            </p>
            <br />
           
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['spedizioniere_doganale'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione.
            </p>
            <br />
            
            <p>
              <b>ESTENSIONI COMPRESE:</b>

        Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright. Perizie, Consulenze e Certificazioni, Consorzio o Joint Venture.
            </p>
            <br />
             <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>

        Mancato beneficio per Sgravi Fiscali.
            </p>
            <br />
           
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['igienisti_dentali'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti.
            </p>
            <br />
                <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni inclusi
            </p>
            <br />
            
            <p>
              <b>ESTENSIONI COMPRESE:</b>

        Primo Soccorso, Cotinuità Assistenziale, Telemedicina e Volontariato, Medico in Sostituzione (solo Medico di Base), Medicina Convenzionale e Vaccinazione, Sonde e Cateteri, Apparecchiature e Strumenti, 81/2008, Tutoring e Docenza, Perizie e Consulenze Tecniche, Fatto di Dipendenti e Collaboratori, Responsabilità Solidale, Tutela dei dati personali, Diffamazione e Danni all'Immagine, Violazione di Copyright.
            </p>
            <br />
             <p>
              <b>ESTENSIONI CON SOVRAPREMIO:</b>

         Medico Frequentatore, Medicina del Servizio di Emergenza Sanitaria, Danni alle Attrezzature di Laboratorio, Direttore Sanitario, Commissario di Gara, Componente Organismo di Mediazione, RC Conduzione dello Studio, Spese di Ripristino della Reputazione.
            </p>
            <br />
           
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['insegnanti_di_educazione_nelle_scuole'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione.
            </p>
            <br />
            
            <p>
              <b>SPESE LEGALI:</b>

                Sono coperte le spese della gestione stragiudiziale e giudiziale delle vertenze in sede civile e penale fino ad 1/4 del massimale
            </p>
            <br />
           
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['insegnanti_di_materie_tecniche_e_scientifiche_in_scuole_a_carattere_professionale'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione.
            </p>
            <br />
            
            <p>
              <b>SPESE LEGALI:</b>

                Sono coperte le spese della gestione stragiudiziale e giudiziale delle vertenze in sede civile e penale fino ad 1/4 del massimale
            </p>
            <br />
           
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['insegnanti_in_asili_e_giardini_infanzia'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione.
            </p>
            <br />
            
            <p>
              <b>SPESE LEGALI:</b>

                Sono coperte le spese della gestione stragiudiziale e giudiziale delle vertenze in sede civile e penale fino ad 1/4 del massimale
            </p>
            <br />
           
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['insegnanti_in_scuole_di_istruzione_elementare_media_secondaria'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione.
            </p>
            <br />
            
            <p>
              <b>SPESE LEGALI:</b>

                Sono coperte le spese della gestione stragiudiziale e giudiziale delle vertenze in sede civile e penale fino ad 1/4 del massimale
            </p>
            <br />
           
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['insegnanti_istruttori_precettori_sorveglianti_in_collegi'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione.
            </p>
            <br />
            
            <p>
              <b>SPESE LEGALI:</b>

                Sono coperte le spese della gestione stragiudiziale e giudiziale delle vertenze in sede civile e penale fino ad 1/4 del massimale
            </p>
            <br />
           
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['insegnanti_presidi_istituti_non_professionali_direttori_didattici'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione.
            </p>
            <br />
            
            <p>
              <b>SPESE LEGALI:</b>

                Sono coperte le spese della gestione stragiudiziale e giudiziale delle vertenze in sede civile e penale fino ad 1/4 del massimale
            </p>
            <br />
           
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['insegnanti_presidi_istituti_professionali'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione.
            </p>
            <br />
            
            <p>
              <b>SPESE LEGALI:</b>

                Sono coperte le spese della gestione stragiudiziale e giudiziale delle vertenze in sede civile e penale fino ad 1/4 del massimale
            </p>
            <br />
           
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['organizmi_di_mediazione'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
                <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />
            
             <p>
              <b>ESTENSIONI CON SOVRAPREMIO:</b>

         Visto Pesante; Visto Leggero senza 730; Visto Leggero con 730; Postuma
            </p>
            <br />
           
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['organismo_composizione_delle_crisi_da_sovraindebitamento'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
                <p>
              <b>RETROATTIVITÀ:</b>
             
             Non Prevista.
            </p>
            <br />
            
             <p>
              <b>ESTENSIONI CON SOVRAPREMIO:</b>

         Visto Pesante; Visto Leggero senza 730; Visto Leggero con 730; Postuma
            </p>
            <br />
           
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['patrocinatori_stragiudiziali'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
                <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />
            
             <p>
              <b>ESTENSIONI CON SOVRAPREMIO:</b>

            Visto Pesante; Visto Leggero senza 730; Visto Leggero con 730; Postuma
            </p>
            <br />
           
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['pedagogista_ed_educatore_professionale_socio_pedagogico'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti.
            </p>
            <br />
                <p>
              <b>RETROATTIVITÀ:</b>
             
             10 anni inclusi.
            </p>
            <br />

              <p>
              <b>ESTENSIONI COMPRESE:</b>

            Postuma Decennale, Primo Soccorso, Cotinuità Assistenziale, Telemedicina e Volontariato, Medico in Sostituzione (solo Medico di Base), Medicina Convenzionale e Vaccinazione, Sonde e Cateteri, Apparecchiature e Strumenti, 81/2008, Tutoring e Docenza, Perizie e Consulenze Tecniche, Fatto di Dipendenti e Collaboratori, Responsabilità Solidale, Tutela dei dati personali, Diffamazione e Danni all'Immagine, Violazione di Copyright.
            </p>
            <br />
            
             <p>
              <b>ESTENSIONI CON SOVRAPREMIO:</b>

            Medico Frequentatore, Medicina del Servizio di Emergenza Sanitaria, Danni alle Attrezzature di Laboratorio, Direttore Sanitario, Commissario di Gara, Componente Organismo di Mediazione, RC Conduzione dello Studio, Spese di Ripristino della Reputazione.
            </p>
            <br />
           
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['periti_edili'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>Ove l'Assicurato abbia iniziato l'attività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
                <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />

              <p>
              <b>ESTENSIONI COMPRESE:</b>

            Consulenza Ambientale, Certificatore Energetico, Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Responsabilità Solidale, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, D.Lgs. n. 81/2008, D.Lgs. n. 624/1996, L. 109/1994 - D. Lgs. 163/06, Contratti con la Pubblica Amministrazione, Attività di Amministratori di Stabili, Mediazione Civile, Commerciale e Tributaria, Asseverazioni.
            </p>
            <br />
            
             <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>

            Spese per il ripristino della Reputazione, Inquinamento Accidentale, RC della Conduzione dello Studio, General Contractor Opere ad Alto Rischio.
            </p>
            <br />    
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['periti_industriali'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>Ove l'Assicurato abbia iniziato l'attività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione.
            </p>
            <br />
                <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />

              <p>
              <b>ESTENSIONI COMPRESE:</b>

            Consulenza Ambientale, Certificatore Energetico, Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Responsabilità Solidale, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, D.Lgs. n. 81/2008, D.Lgs. n. 624/1996, L. 109/1994 - D. Lgs. 163/06, Contratti con la Pubblica Amministrazione, Attività di Amministratori di Stabili, Mediazione Civile, Commerciale e Tributaria, Asseverazioni.
            </p>
            <br />
            
             <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>

            Spese per il ripristino della Reputazione, Inquinamento Accidentale, RC della Conduzione dello Studio, General Contractor Opere ad Alto Rischio.
            </p>
            <br />    
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['rcp_autoscuole'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['uffici_pratiche_auto'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />  
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['servizi_informatici'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
                <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />

              <p>
              <b>ESTENSIONI COMPRESE:</b>

            Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Violazione di Copyright, Perdita Documenti, Diffamazione e Danni all' immagine, Perdita o danneggiamento Dati di terzi, Diritti d'autore/Marchi di fabbrica, Trasmissione di Virus informatici.
            </p>
            <br />
            
             <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>

            Contratti con la Pubblica Amministrazione, Spese Ripristino Reputazione, R.C. Conduzione Studio
            </p>
            <br />    
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
               La Polizza prevede il Tacito Rinnovo, in mancanza di disdetta pervenuta nei 30 giorni antecedenti alla data di scadenza viene automaticamente rinnovata.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['tirocinanti_no_area_medica'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
            Durata della Polizza: 12 mesi
            </p>
            </br>
               <p>

                Tariffa non valida per Professioni Mediche
            </p>
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
             2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
           
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
               La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['avvocato_sindaco'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />

            <p>Ove l'Assicurato abbia iniziato l'attività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.
            </p>
            <br/>
            <p>
             
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
              2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             Illimitata.
            </p>
            <br />
               <p>
              <b>Postuma:</b>
             
            10 Anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

             Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Responsabilità Solidale, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, Funzioni di Arbutro, Sostituti d'Udienza, Attività di Amministratore di Stabili, Mediazione Civile, Commerciale e Tributaria. 
            </p>
            <br />
            <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>
             
              Funzioni Pubbliche, Conduzione dello Studio, Spese Ripristino Reputazione, Attività Fiscale e Tributaria.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
            La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['commercialisti_sindaci_revisori'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />

            <p>Ove l'Assicurato abbia iniziato l'attività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.

            </p>
            <br/>
            <p>
             
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
             2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

             Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, Funzioni di Arbutro, Servizi di EDP, Attività di Amministratore di Stabili, Mediazione Civile, Commerciale e Tributaria, Spese per il Ripristino della Reputazione, Liquidatore Curatore Commissario, Conduzione dello Studio.
            </p>
            <br />
            <p>
              <b>ESTENSIONI CON SOVRAPREMIO:</b>
             
              Visto Pesante; Visto Leggero, Fusioni e Acquisizioni, Estensione al periodo di Retroattività.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
           La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['consulenti_del_lavoro_con_auditors'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />

            <p>Ove l'Assicurato abbia iniziato l'attività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.
            </p>
            <br/>
            <p>
             
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
            2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

             Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, Funzioni di Arbutro, Servizi di EDP, Attività di Amministratore di Stabili, Mediazione Civile, Commerciale e Tributaria, Spese per il Ripristino della Reputazione, Liquidatore Curatore Commissario, Conduzione dello Studio.
            </p>
            <br />
            <p>
              <b>ESTENSIONI CON SOVRAPREMIO:</b>
             
               Visto Pesante; Visto Leggero, Fusioni e Acquisizioni, Estensione al periodo di Retroattività.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
           La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['revisore_contabili'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />

            <p>Ove l'Assicurato abbia iniziato l'attività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.
            </p>
            <br/>
            <p>
             
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
            2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissiones
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

             Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, Funzioni di Arbutro, Servizi di EDP, Attività di Amministratore di Stabili, Mediazione Civile, Commerciale e Tributaria, Spese per il Ripristino della Reputazione, Liquidatore Curatore Commissario, Conduzione dello Studio.
            </p>
            <br />
            <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA::</b>
             
               Visto Pesante; Visto Leggero, Fusioni e Acquisizioni, Estensione al periodo di Retroattività.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
           La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['revisore_contabili_sindaco'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />

            <p>Ove l'Assicurato abbia iniziato l'attività e sia iscritto all'albo professionale da non più di tre anni ed abbia inoltre ricavi inferiori a € 15.000,00 è possibile applicare una scontistica riservata ai giovani professionisti.
            </p>
            <br/>
            <p>
             
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
            2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissiones
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

             Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, Funzioni di Arbutro, Servizi di EDP, Attività di Amministratore di Stabili, Mediazione Civile, Commerciale e Tributaria, Spese per il Ripristino della Reputazione, Liquidatore Curatore Commissario, Conduzione dello Studio.
            </p>
            <br />
            <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA::</b>
             
               Visto Pesante; Visto Leggero, Fusioni e Acquisizioni, Estensione al periodo di Retroattività.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
           La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },

  {
    profession_code: ['perito_agrario'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
             2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             5 anni.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

          Consulenza Ambientale, Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Responsabilità Solidale, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright. 


            </p>
            <br />
            <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>
             
               Spese per il ripristino della Reputazione, Inquinamento Accidentale, RC della Conduzione dello Studio.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },
  {
    profession_code: ['archeologo', 'adattatore_di_dialoghi', 'agenzie_matrimoniali', 'arbitri', 'archivista', 'agenzia_di_collocamento', 'brand_manager', 'commissioni_esaminatrici', 'attivita_per_conformita_ed_adempimenti', 'audiologia', 'bibliotecario', 'book_keeper', 'coaching', 'certificatore_energetico', 'consulente_assicurativo_no_rui', 'consulente_farmaceutico', 'conservazione_documentale', 'consulente_alimentare', 'consulenza_immagine', 'consulente_familiare', 'consulente_chimico', 'consulenza_acustica', 'consulenza_antincendio', 'consulenza_arboriale', 'consulenza_agricolo_forestale', 'consulenza_barriere_architettoniche',
      'consulenza_corporate_indentity', 'consulenza_ecologica', 'consulenza_efficienza_energetica', 'consulenza_export', 'consulenza_forense', 'consulenza_energia', 'consulenza_gestionale', 'consulenza_formazione', 'consulenza_genealogia'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
             2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione.
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             Non prevista.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

         Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, Perizie Consulenze e Certificazioni, Consorzio o Joint Venture.
            </p>
            <br />
            <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>
             
             Spese per il Ripristino della Reputazione, RC della Conduzione dello Studio, Responsabilità Solidale.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },
  {
    profession_code: ['consulenza_igiene_alimentare', 'consulenza_illuminazione', 'consulenza_immigrazione', 'consulenza_grafologica', 'consulenza_marketing', 'consulenza_nutrizionale', 'consulenza_orticoltura', 'consulenza_per_catering', 'pubbliche_relazioni', 'consulenza_salute_sicurezza', 'consulenza_per_orientamento', 'consulenza_ricerche_mercato', 'consulenza_risorse_umane', 'consulenza_traffico', 'consulenza_urbanistica', 'consulenza_zoologica', 'coordinatore_risorse_umane', 'corsi_formazione_aziendale', 'dermopigmentisti_trucco_permanente', 'direttore_artistico', 'dog_sitter', 'doppiatore', 'ecologo', 'disegnatore_industriale', 'economista', 'editore', 'enologo', 'ricostruttori_unghie', 'tatuatore', 'tecnico_controllo_qualita', 'estetista', 'prevenzione_incidenti', 'formatore', 'promotore_organizzazione_benefiche', 'promotore_turistico'],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
             2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione.
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             Non prevista.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

         Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, Perizie Consulenze e Certificazioni, Consorzio o Joint Venture.
            </p>
            <br />
            <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>
             
             Spese per il Ripristino della Reputazione, RC della Conduzione dello Studio, Responsabilità Solidale.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },
  {
    profession_code: ['esperto_di_arti_visive', 'formazioni_di_segreteria', 'terapista_vocale', 'test_non_distruttivi', 'formatore_corsi_professionali_pubblici_privati', 'fotografia', 'telemarketing',
      'terapista_musicale', 'traduttore', 'mirocredito', 'wedding_planner', 'garden_design', 'publishing', 'geografo', 'gestioni_interinali', 'grafologo', 'graphic_design', 'giardiniere', 'interior_designer', 'indagini_inchieste_su_incidenti', 'indagini_private', 'informatore_scientifico_del_farmaco', 'interprete', 'insegnanti_di_dizione_dramma', 'intrattenitore_culturale', 'storico', 'storico_arte', 'inventari', 'servizi_segretariato', 'statistico', 'investigatore_privato', 'insegnanti_scuole_musica', 'servizi_copia_duplicazione', 'servizi_pagamento_paghe', 'servizi_risposta_telefonica', 'servizi_stampe_fotocopie', 'stilista',

    ],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
             2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione.
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             Non prevista.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

         Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, Perizie Consulenze e Certificazioni, Consorzio o Joint Venture.
            </p>
            <br />
            <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>
             
             Spese per il Ripristino della Reputazione, RC della Conduzione dello Studio, Responsabilità Solidale.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },
  {
    profession_code: ['istruttore_di_guida', 'manager_coach', 'mediatore', 'metereologo', 'organizzazione_eventi_conference', 'pedagogo', 'pompe_funebri', 'istruttore_attivita_motorie', 'istruttore_yoga', 'istruttore_ginnastica_dolce', 'istruttore_ginnastica_posturale', 'istruttore_karate', 'istruttore_pilates', 'istruttore_spinning', 'istruttore_di_tennis', 'life_coach', 'laboratorio_analisi', 'musicista_produttore', 'organizzazione_conference', 'personal_trainer', 'mediatore_marittimi',
    ],
    information: `
              <div className="card-extra-information">
            <h3>Informazioni</h3>
            <br />
            <p>La validità della quotazione è di 30 giorni. La stessa non è da intendersi definitiva e dovrà essere confermata al ricevimento della documentazione richiesta.</p>
            <br />
            <p>
              <b>TEMPI DI EMISSIONE INDICATIVI:</b>
             
             2 Giorni lavorativi dalla ricezione dei documenti in caso di procedura standard; 5-10 minuti in caso di auto emissione.
            </p>
            <br />
            <p>
              <b>RETROATTIVITÀ:</b>
             
             Non prevista.
            </p>
            <br />
            <p>
              <b>ESTENSIONI COMPRESE:</b>

         Perdita di Documenti, Fatto dei Dipendenti e Collaboratori, Tutela dei Dati Personali / Codice Privacy (D.Lgs. 196/2003), Diffamazione e Danni all'Immagine, Violazione di Copyright, Perizie Consulenze e Certificazioni, Consorzio o Joint Venture.
            </p>
            <br />
            <p>
              <b>ESTENSIONI A PATTUIZIONE ESPRESSA:</b>
             
             Spese per il Ripristino della Reputazione, RC della Conduzione dello Studio, Responsabilità Solidale.
            </p>
            <br />
            <p>
              <b>CESSAZIONE E RINNOVO:</b>
             
                La Polizza non prevede il Tacito Rinnovo, la copertura termina alla sua naturale scadenza.
            </p>

          </div>
        `,
  },
];
